// extracted by mini-css-extract-plugin
export var header = "Header-module--header--357cc";
export var header__logo = "Header-module--header__logo--fbf2c";
export var header__logo_open = "Header-module--header__logo_open--4b5fa";
export var header__menu = "Header-module--header__menu--a1981";